import React from 'react'

import clamp from 'lodash-es/clamp'

import T from 'components/FormattedMessage'
import Paper from 'components/Paper'
import ProgressBar from 'components/ProgressBar'

import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'

import backgroundImage from './assets/background.png'

interface Props {
  numUnlocked: number
  numTotal: number
}

const styles = (theme: Theme) => createStyles({
  root: {
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundImage})`,
    backgroundPosition: 'center'
  },
  progress: {
    marginTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const AchievementSummary: React.SFC<InjectedProps> = ({ classes, numUnlocked, numTotal }) => {
  numTotal = clamp(numTotal, 0, Infinity)
  numUnlocked = clamp(numUnlocked, 0, numTotal)

  const progress = numTotal !== 0 ? numUnlocked / numTotal : 0
  const rank = Math.min(10, Math.floor(progress * 10))

  return (
    <Paper className={classes.root} pad="medium">
      <Typography variant="h3" align="center">
        <T id="achievements_rank_title" />
      </Typography>
      <Typography variant="h5" align="center">
        <T id={`achievements_rank_${rank}`} />
      </Typography>
      <ProgressBar
        min={0}
        max={numTotal}
        value={numUnlocked}
        label={`${numUnlocked} / ${numTotal}`}
        className={classes.progress}
        color="primary"
      />
      <Typography variant="h3" align="center">
        <T id={progress < 1.0 ? 'achievements_rank_help' : 'achievements_rank_max'} />
      </Typography>
    </Paper>
  )
}

export default withStyles(styles)(AchievementSummary)
